import { createSelector } from "reselect";

export const selectSoftwarePackages = (state) =>
  state.softwarePackage?.softwarePackages || [];

export const isLoadingSoftwarePackages = (state) =>
  state.softwarePackage?.loadingSoftwarePackages;

export const selectSoftwarePackageById = createSelector(
  [(state, props) => props.identifier, selectSoftwarePackages],
  (softwarePackageId, softwarePackages) => {
    if (!softwarePackages || softwarePackages.length === 0) return null;
    if (!softwarePackageId) return undefined;
    return softwarePackages.find((pkg) => pkg.id === softwarePackageId);
  },
);
